<template>
  <div class="common-stacking-bar">
    <div v-resize="resizeChart" :id="barIdName" :style="{width: width, height: height}"></div>
  </div>
</template>

<script>
  import {debounce} from "../../../utils/util"
  export default {
    name: 'common-stacking-bar',
    props: {
      barIdName: {
        type: String,
        default () {
          return 'commonStackingBar'
        }
      },
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '220px'
        }
      },
      titleShow: {
        type: Boolean,
        default () {
          return true
        }
      },
      barTitle: {
        type: String,
        default () {
          return ''
        }
      },
      colorList: {
        type: Array,
        default () {
          return ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5']
        }
      },
      legendData: {
        type: Array,
        default () {
          return []
        }
      },
      xAxis: {
        type: Object,
        default () {
          return {}
        }
      },
      yAxis: {
        type: Object,
        default () {
          return {}
        }
      },
      series: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {
        commonStackingBar: null
      }
    },
    mounted () {
      this.drawCommonHorizontalBar()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeChart)
    },
    directives:{
      resize: { // 指令的名称
        bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
          console.log(el,"绑定",binding);
          let width = '', height = '';
          function isReize() {
            const style = document.defaultView.getComputedStyle(el);
            if (width !== style.width || height !== style.height) {
              binding.value({width:style.width,height:style.height});  // 关键(这传入的是函数,所以执行此函数)
            }
            width = style.width;
            height = style.height;
          }
          el.__vueSetInterval__ = setInterval(isReize, 300);
        },
        unbind(el) {
          console.log(el,"解绑");
          clearInterval(el.__vueSetInterval__);
        }
      }
    },
    methods: {
      drawCommonHorizontalBar() {
        this.commonStackingBar = this.$echarts.init(document.getElementById(this.barIdName))
        this.commonStackingBar.setOption({
          title: {
            show: this.titleShow,
            text: this.barTitle,
            titleStyle: {
              color: '#333333'
            }
          },
          tooltip : {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            data: this.legendData,
            right: 10
          },
          grid: {
            left: '30px',
            right: '50px',
            bottom: '3%',
            containLabel: true
          },
          color: this.colorList,
          xAxis: this.xAxis,
          yAxis: this.yAxis,
          series: this.series
        })
      },
      resizeChart: debounce(function () {
        this.commonStackingBar.resize()
      }, 100)
    },
    watch: {
      series () {
        this.drawCommonHorizontalBar()
      }
    }
  }
</script>

<style scoped>
  .common-stacking-bar {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Echarts/Bar/commonStackingBar.vue